{
  "status": {
    "loaded": "Лицензия загружена",
    "notFound": "Не найдена или повреждена"
  },
  "label": {
    "status": "Статус лицензии",
    "requestTitle": "Запрос лицензии"
  },
  "section": {
    "owner": "Правообладатель",
    "licenseInfo": "Информация о лицензии",
    "licenseUsage": "Использование лицензии"
  },
  "field": {
    "country": "Страна регистрации организации",
    "state": "Регион регистрации организации",
    "locality": "Город регистрации организации",
    "organization": "Название организации",
    "domain": "Доменное имя сервера Памир",
    "email": "E-mail представителя организации",
    "type": "Тип лицензии",
    "expiration": "Срок действия лицензии",
    "issueTime": "Время выпуска лицензии",
    "controlledObjects": "Количество объектов контроля",
    "allowCis": "Количество КЕ"
  },
  "button": {
    "request": "Запросить лицензию",
    "upload": "Загрузить лицензию"
  },
  "action": {
    "successSaveMsg": "Успешно загружено"
  },
  "text": {
    "of": "из",
    "used": "Использовано",
    "remaining": "Доступно",
    "exceeded": "Перерасход лицензии",
    "controlledObjects": "Объект контроля",
    "allowCis": "Конфигурационная единица"
  },
  "service": {
    "CMDB": "CMDB",
    "Monitoring": "Мониторинг"
  },
  "placeholders": {
    "country": "Выберите страну",
    "city": "Москва",
    "type": "стандартная / профессиональная / временная",
    "unlimited": "Неограничено",
    "unlimitedPeriod": "Бессрочно",
    "domain": "pamir.local",
    "email": "ivan.ivanov@company.com"
  },
  "types": {
    "temporary": "Временная",
    "standard": "Стандартная",
    "professional": "Профессиональная"
  }
}